'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _MobileAppButtons = require('./MobileAppButtons.scss');

var _MobileAppButtons2 = _interopRequireDefault(_MobileAppButtons);

var _Language = require('../../helpers/Language');

var _Product = require('../../helpers/Product');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileAppButtons = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MobileAppButtons, _Component);

  function MobileAppButtons() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MobileAppButtons);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MobileAppButtons.__proto__ || (0, _getPrototypeOf2.default)(MobileAppButtons)).call.apply(_ref, [this].concat(args))), _this), _this.getAppleUrl = function () {
      var productName = _this.props.auth.productName;

      switch (productName) {
        case _Product.PRODUCT_NAMES.Music:
          return 'https://itunes.apple.com/ca/app/stingray-music/id420661098';
        default:
          throw new Error('Cannot find Apple url: Product ' + productName + ' not supported');
      }
    }, _this.getGoogleUrl = function () {
      var productName = _this.props.auth.productName;

      switch (productName) {
        case _Product.PRODUCT_NAMES.Music:
          return 'https://play.google.com/store/apps/details?id=com.stingray.galaxie.android';
        default:
          throw new Error('Cannot find Google url: Product ' + productName + ' not supported');
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MobileAppButtons, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var componentClassName = _MobileAppButtons2.default.content + (className ? ' ' + className : '');
      var appleStoreImg = (0, _Language.translateResource)(this.props.lang, _Language.resources.AppleStore);
      var googleStoreImg = (0, _Language.translateResource)(this.props.lang, _Language.resources.GoogleStore);
      return _react2.default.createElement(
        'div',
        { className: componentClassName },
        _react2.default.createElement(
          'a',
          { href: this.getGoogleUrl(), target: '_blank', rel: 'noopener noreferrer' },
          _react2.default.createElement('img', { className: _MobileAppButtons2.default.googleButton, src: googleStoreImg })
        ),
        _react2.default.createElement(
          'a',
          { href: this.getAppleUrl(), target: '_blank', rel: 'noopener noreferrer' },
          _react2.default.createElement('img', { className: _MobileAppButtons2.default.appleButton, src: appleStoreImg })
        )
      );
    }
  }]);
  return MobileAppButtons;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object,
  className: _react.PropTypes.string,
  lang: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = MobileAppButtons;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileAppButtons/MobileAppButtons.js
// module id = 1961
// module chunks = 0